import { render, staticRenderFns } from "./SuperAdminAgencies.vue?vue&type=template&id=0dd15c42&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./SuperAdminAgencies.vue?vue&type=script&lang=js"
export * from "./SuperAdminAgencies.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminAgencies.vue?vue&type=style&index=0&id=0dd15c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd15c42",
  null
  
)

export default component.exports